import {typeExport} from "../../../../../redux/store/type";


const reducerChangeInformationScreen = (state = {
    NoInternetDialog: false,
    results: null,
    isLoading: false,
}, action) => {
    switch (action.type) {
        case typeExport.ChangeInformationScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialog: false,
                isLoading: true,
                results: null

            };

        case typeExport.ChangeInformationScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialog: true,
                isLoading: false,
                error: action.error
            };
        case typeExport.ChangeInformationScreen_SERVICE_SUCCESS:
            return {
                ...state,
                results: action.results,
                NoInternetDialog: false,
                isLoading: false,

            };

        case typeExport.ChangeInformationScreen_SERVICE_REFRESH:
            return {
                ...state,
                results: action.results,
                NoInternetDialog: false,
                isLoading: false,
            };
        case typeExport.ChangeInformationScreen_SERVICE_PENDING_SET:
            return {
                ...state,
                NoInternetDialogSet: false,
                isLoadingSet: true,
                resultsSet: null

            };

        case typeExport.ChangeInformationScreen_SERVICE_ERROR_SET:
            return {
                ...state,
                NoInternetDialogSet: true,
                isLoadingSet: false,
                error: action.error
            };
        case typeExport.ChangeInformationScreen_SERVICE_SUCCESS_SET:
            return {
                ...state,
                resultsSet: action.resultsSet,
                NoInternetDialogSet: false,
                isLoadingSet: false,

            };

        case typeExport.ChangeInformationScreen_SERVICE_REFRESH_SET:
            return {
                ...state,
                resultsSet: action.resultsSet,
                NoInternetDialogSet: false,
                isLoadingSet: false,
            };

        default:
            return state;
    }
}

export default reducerChangeInformationScreen;
